(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fnp-product-mobile-fix"]) return;
  try {
    
function initFnpOptionFix(root) {
  var scope = root || document;
  var productShell = document.querySelector('.fnp-product-shell');
  if (productShell && productShell.getAttribute('data-fnp-polish-ready') !== 'true') {
    productShell.setAttribute('data-fnp-polish-ready', 'true');
    var staticProof = productShell.querySelector('.fnp-social-proof');
    var realProof = document.querySelector('[data-fnp-real-social-proof]');
    var priceRow = productShell.querySelector('.fnp-price-row');
    if (staticProof) staticProof.remove();
    if (realProof && priceRow) {
      realProof.hidden = false;
      priceRow.insertAdjacentElement('afterend', realProof);
    }
    productShell.querySelectorAll('.fnp-info-grid details').forEach(function(details) {
      details.removeAttribute('open');
    });
  }

  var panels = scope.querySelectorAll('[data-fnp-option-fix]');
  if (!panels.length && scope !== document) panels = document.querySelectorAll('[data-fnp-option-fix]');
  panels.forEach(function(panel) {
    if (panel.getAttribute('data-fnp-option-ready') === 'true') return;
    var shell = document.querySelector('.fnp-product-shell');
    var form = shell ? shell.querySelector('.fnp-product-form') : document.querySelector('.fnp-product-form');
    if (!form) return;
    panel.setAttribute('data-fnp-option-ready', 'true');
    panel.hidden = false;
    var insertBefore = form.querySelector('.fnp-app-zone--form') || form.querySelector('.fnp-buy-row');
    if (panel.parentElement !== form) {
      if (insertBefore) {
        form.insertBefore(panel, insertBefore);
      } else {
        form.appendChild(panel);
      }
    }
    form.classList.add('fnp-has-option-fix');

    panel.querySelectorAll('[data-fnp-swatch-fallback]').forEach(function(swatch) {
      var colorName = (swatch.getAttribute('data-fnp-swatch-fallback') || '').toLowerCase();
      var compact = colorName.replace(/[^a-z]/g, '');
      var colorMap = {
        black:'#111827', white:'#ffffff', red:'#dc2626', blue:'#2563eb', navy:'#1e3a8a', green:'#16a34a', yellow:'#facc15', gold:'#d4af37', silver:'#c0c0c0', grey:'#9ca3af', gray:'#9ca3af', pink:'#ec4899', purple:'#7c3aed', orange:'#f97316', brown:'#8b5a2b', maroon:'#800000', cream:'#fff4d6', beige:'#d8c3a5'
      };
      var color = colorMap[compact] || '#d8dde6';
      if (colorName.indexOf('rose') > -1 && colorName.indexOf('gold') > -1) color = '#b76e79';
      if (colorName.indexOf('dark') > -1 && colorName.indexOf('green') > -1) color = '#166534';
      if (colorName.indexOf('dark') > -1 && colorName.indexOf('blue') > -1) color = '#1e3a8a';
      if (colorName.indexOf('light') > -1 && colorName.indexOf('blue') > -1) color = '#93c5fd';
      if (colorName.indexOf('light') > -1 && colorName.indexOf('pink') > -1) color = '#f9a8d4';
      swatch.style.setProperty('--fnp-swatch-color', color);
    });

    var section = form.closest('[data-fnp-section]') || shell || document;
    var variantsScript = panel.querySelector('[data-fnp-option-variants]');
    var variants = [];
    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }
    var optionGroups = Array.prototype.slice.call(panel.querySelectorAll('[data-fnp-option-group]'));
    var optionButtons = Array.prototype.slice.call(panel.querySelectorAll('[data-fnp-option-button]'));
    var variantInput = form.querySelector('[data-fnp-variant-id]');
    var current = section.querySelector('[data-fnp-price-current]');
    var compare = section.querySelector('[data-fnp-price-compare]');
    var discount = section.querySelector('[data-fnp-discount]');
    var addButton = section.querySelector('[data-fnp-add-button]');
    var addText = section.querySelector('[data-fnp-add-text]');

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function(group) {
        var index = Number(group.getAttribute('data-option-index') || 0);
        var selectedButton = group.querySelector('[data-fnp-option-button].is-selected');
        selected[index] = selectedButton ? (selectedButton.getAttribute('data-option-value') || '') : '';
      });
      return selected;
    }

    function sameOptions(variant, selected) {
      if (!variant || !variant.options || variant.options.length !== selected.length) return false;
      for (var index = 0; index < selected.length; index += 1) {
        if (variant.options[index] !== selected[index]) return false;
      }
      return true;
    }

    function findVariant(selected) {
      for (var index = 0; index < variants.length; index += 1) {
        if (sameOptions(variants[index], selected)) return variants[index];
      }
      return null;
    }

    function updateOptionLabels() {
      optionGroups.forEach(function(group) {
        var selectedButton = group.querySelector('[data-fnp-option-button].is-selected');
        var label = group.querySelector('[data-fnp-option-current]');
        if (selectedButton && label) label.textContent = selectedButton.getAttribute('data-option-value') || '';
      });
    }

    function updateButtonAvailability() {
      var selected = getSelectedOptions();
      optionButtons.forEach(function(button) {
        var optionIndex = Number(button.getAttribute('data-option-index') || 0);
        var candidate = selected.slice();
        candidate[optionIndex] = button.getAttribute('data-option-value') || '';
        var possible = variants.some(function(variant) {
          if (!variant || !variant.options) return false;
          for (var index = 0; index < candidate.length; index += 1) {
            if (candidate[index] && variant.options[index] !== candidate[index]) return false;
          }
          return true;
        });
        button.classList.toggle('is-unavailable', !possible);
        button.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });
    }

    function applyVariant(variant) {
      if (variant && variantInput) variantInput.value = String(variant.id || '');
      if (variant && current) current.textContent = variant.priceText || '';
      var compareValue = variant ? (variant.compareText || '') : '';
      if (compare) {
        compare.textContent = compareValue;
        compare.classList.toggle('is-hidden', compareValue === '');
      }
      if (discount) {
        var priceRaw = variant ? Number(variant.price || 0) : 0;
        var compareRaw = variant ? Number(variant.compareAtPrice || 0) : 0;
        if (compareRaw > priceRaw) {
          discount.textContent = Math.round(((compareRaw - priceRaw) * 100) / compareRaw) + '% off';
          discount.classList.remove('is-hidden');
        } else {
          discount.classList.add('is-hidden');
        }
      }
      var available = Boolean(variant && variant.available);
      if (addButton) addButton.disabled = !available;
      if (addText && addButton) {
        addText.textContent = available ? (addButton.getAttribute('data-add-text') || 'Add to cart') : (variant ? (addButton.getAttribute('data-sold-text') || 'Sold out') : 'Unavailable');
      }
    }

    optionButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var optionIndex = button.getAttribute('data-option-index');
        var siblings = panel.querySelectorAll('[data-fnp-option-button][data-option-index="' + optionIndex + '"]');
        siblings.forEach(function(item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        updateOptionLabels();
        updateButtonAvailability();
        applyVariant(findVariant(getSelectedOptions()));
      });
    });

    updateOptionLabels();
    updateButtonAvailability();
    applyVariant(findVariant(getSelectedOptions()));
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initFnpOptionFix(document); });
} else {
  initFnpOptionFix(document);
}
document.addEventListener('shopify:section:load', function(event) { initFnpOptionFix(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnp-product-template"] && !Shopify.designMode) return;
  try {
    
function initFnpProductSections(root) {
  var scope = root || document;
  var sections = scope.querySelectorAll('[data-fnp-section]');
  sections.forEach(function(section) {
    if (section.getAttribute('data-fnp-ready') === 'true') return;
    section.setAttribute('data-fnp-ready', 'true');
    var stage = section.querySelector('.fnp-media-stage');
    var thumbs = section.querySelectorAll('[data-fnp-thumb]');
    var panels = section.querySelectorAll('[data-fnp-media]');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var index = thumb.getAttribute('data-fnp-thumb');
        thumbs.forEach(function(item) { item.classList.remove('is-active'); });
        panels.forEach(function(panel) { panel.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var active = section.querySelector('[data-fnp-media="' + index + '"]');
        if (active) {
          active.classList.add('is-active');
          if (stage && window.matchMedia('(max-width: 640px)').matches) {
            active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        }
      });
    });
    if (stage && panels.length > 1) {
      stage.addEventListener('scroll', function() {
        if (!window.matchMedia('(max-width: 640px)').matches) return;
        var index = Math.round(stage.scrollLeft / stage.clientWidth);
        thumbs.forEach(function(item) { item.classList.remove('is-active'); });
        var activeThumb = section.querySelector('[data-fnp-thumb="' + index + '"]');
        if (activeThumb) activeThumb.classList.add('is-active');
      }, { passive: true });
    }
    var pinInput = section.querySelector('[data-fnp-pin-input]');
    var pinButton = section.querySelector('[data-fnp-pin-button]');
    var pinResult = section.querySelector('[data-fnp-pin-result]');
    if (pinButton && pinInput && pinResult) {
      pinButton.addEventListener('click', function() {
        var value = pinInput.value.replace(/\D/g, '').slice(0, 6);
        pinInput.value = value;
        if (value.length < 5) {
          pinResult.textContent = 'Enter a valid pincode to check delivery.';
          return;
        }
        pinResult.textContent = 'Delivery available for ' + value + '. Estimated delivery in 3-7 days.';
      });
    }
    var variantInput = section.querySelector('[data-fnp-variant-id]');
    var variantButtons = section.querySelectorAll('[data-fnp-variant-button]');
    variantButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        if (button.disabled) return;
        variantButtons.forEach(function(item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = button.getAttribute('data-variant-id') || '';
        var current = section.querySelector('[data-fnp-price-current]');
        var compare = section.querySelector('[data-fnp-price-compare]');
        var discount = section.querySelector('[data-fnp-discount]');
        var addButton = section.querySelector('[data-fnp-add-button]');
        var addText = section.querySelector('[data-fnp-add-text]');
        if (current) current.textContent = button.getAttribute('data-price') || '';
        var compareValue = button.getAttribute('data-compare') || '';
        if (compare) {
          compare.textContent = compareValue;
          compare.classList.toggle('is-hidden', compareValue === '');
        }
        var priceRaw = Number(button.getAttribute('data-price-raw') || 0);
        var compareRaw = Number(button.getAttribute('data-compare-raw') || 0);
        if (discount) {
          if (compareRaw > priceRaw) {
            discount.textContent = Math.round(((compareRaw - priceRaw) * 100) / compareRaw) + '% off';
            discount.classList.remove('is-hidden');
          } else {
            discount.classList.add('is-hidden');
          }
        }
        var available = button.getAttribute('data-available') === 'true';
        if (addButton) addButton.disabled = !available;
        if (addText && addButton) addText.textContent = available ? addButton.getAttribute('data-add-text') : addButton.getAttribute('data-sold-text');
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initFnpProductSections(document); });
} else {
  initFnpProductSections(document);
}
document.addEventListener('shopify:section:load', function(event) { initFnpProductSections(event.target); });

  } catch(e) { console.error(e); }
})();
})();
